import React from "react";
import GatsbyLink from "../../GatsbyLink";
import RenderContent from "../../RenderContent";
import { ImagePass } from "../../Image/ImagePass";
import "./LinkList.scss";

export const LinkList = (props) => {
  const { links, title, introContent, listView, siteUrl } = props;
  return (
    <section className="links-list">
      <div className="wrap">
        <div className="intro">
          {title && (
            <h2
              className="section-title"
              dangerouslySetInnerHTML={{ __html: title }}
            />
          )}
          {introContent && (
            <RenderContent className="intro-text" content={introContent} />
          )}
        </div>
        <div className={`links${listView ? " list" : " tiles"}`}>
          {links &&
            links.map(
              (link, index) =>
                link.link &&
                link.link.url && (
                  <GatsbyLink
                    className="item"
                    key={index}
                    to={link.link.url.replace(
                      process.env.GATSBY_WP_ADDRESS,
                      siteUrl
                    )}
                    target={link.link.target}
                  >
                    <div className="container secondary">
                      {link.image && link.image && (
                        <div className="background">
                          <ImagePass src={link.image} />
                        </div>
                      )}
                      <div className="content">
                        {link.description && (
                          <RenderContent content={link.description} />
                        )}
                      </div>
                      {link.link.title && (
                        <button className="button--light">
                          {link.link.title}
                        </button>
                      )}
                    </div>
                  </GatsbyLink>
                )
            )}
        </div>
      </div>
    </section>
  );
};
